import { FaCheckCircle } from "components/atoms/Icon/fa/FaCheckCircle";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import FormCountries from "components/molecules/FormCountries";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";
import RequiredDocuments from "components/organisms/RequiredDocument";

import AccountingAuditing from "./AccountingAuditing";
import TaxFilingServices from "./TaxFilingServices";

const Component = ({ data }) => {
  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-min-h-635"
          title="Accounting,<br/>Auditing & Tax Filing<br/>in Vietnam"
          bgColor="bg-bbc-country"
          breadcrumbs={data?.banner?.breadcrumbs}
          leftClassName="relative mt-4 lg:mt-0 col-12 lg:col-7"
          leftContent={
            <div className=" mb-6 lg:mt-10 lg:mb-10">
              {data?.banner?.options.length > 0 &&
                data?.banner?.options.map((item, index) => (
                  <div
                    key={index}
                    className="mb-2 flex items-center last:mb-0 "
                  >
                    <FaCheckCircle className="mr-2 text-[#21B350]" size={12} />{" "}
                    <span className="font-medium leading-6 text-bbc-brand-800">
                      {item}
                    </span>
                  </div>
                ))}
            </div>
          }
          rightClassName="col-12 lg:col-5 pb-[26px]"
          rightContent={
            <Img
              src="/assets/images/common/accounting-auditing-banner.png"
              width={622}
              height={400}
              alt="accounting services in Vietnam"
              className="lg:absolute lg:top-24"
              wrapper={{
                className: "bbc-banner-image-country banner-lg-top-12",
              }}
              priority={true}
            />
          }
        />
      </section>
      <section>
        <div className="container">
          <div>
            <Title
              text="Our Services"
              className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
            />
            <p className="mb-6 leading-bbc-26 lg:mb-4">
              All companies in Vietnam have to comply with the requirements set
              forth in the Law on Accounting and the Vietnam Accounting
              Standard. If your business is new to the country, you may find
              these financial reporting requirements troublesome and
              time-consuming.
            </p>
            <p className="mb-6 leading-bbc-26 lg:mb-4">
              That’s why BBCIncorp is here, to provide you with a set of
              comprehensive accounting services. When using our services, you
              can relieve your company from the heavy burden of compliance. You
              will get more time and resources to focus more on running your
              company in Vietnam.
            </p>
          </div>
        </div>
      </section>
      <section>
        <AccountingAuditing
          services={data?.accountingService?.serviceFees}
          title="Accounting Service"
          country={data.country}
          data={data?.accountingService}
        />
      </section>
      <section>
        <TaxFilingServices data={data.taxFilingServices} />
      </section>
      <RequiredDocuments
        sectionClassName="mb-10 lg:mb-20 pt-14 pb-20"
        backgroundImage="/assets/images/common/required-documents.png"
        title="What you'll need to prepare"
        data={data?.dataRequiredDocuments}
      />
      <section className="relative">
        <div className="container relative z-10">
          <div className="m-auto lg:col-10">
            <FormCountries
              title={data.dataFormContact.title}
              description={data.dataFormContact.description}
              country_id={244}
            />
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:mx-auto">
            <Faqs
              data={data?.dataFaqs}
              description="Get to know more with frequently asked questions."
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Component;
